<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}工单标签
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
            v-if="(dispatchStatEdit && tenant.id != null) || (dispatchStatAdd && tenant.id == null)"
            @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    工单标签
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.dispatchStat" @blur="inspection" clearable />
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    工单查询栏目是否显示
                  </th>
                  <td>
                    <el-radio v-model="tenant.isShow" :label="0">否</el-radio>
                    <el-radio v-model="tenant.isShow" :label="1">是</el-radio>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    网点备注操作是否显示
                  </th>
                  <td>
                    <el-radio v-model="tenant.showInSiteRemark" :label="0">否</el-radio>
                    <el-radio v-model="tenant.showInSiteRemark" :label="1">是</el-radio>
                  </td>
                  <th>
                    总部备注操作是否显示
                  </th>
                  <td>
                    <el-radio v-model="tenant.showInRemark" :label="0">否</el-radio>
                    <el-radio v-model="tenant.showInRemark" :label="1">是</el-radio>
                  </td>
                </tr>
                <tr>
                  <th>
                    显示颜色
                  </th>
                  <td>
                    <el-select v-model="tenant.color">
                      <el-option label="不显示" :value="0" />
                      <el-option label="yellow" :value="1" />
                      <el-option label="green" :value="2" />
                      <el-option label="red" :value="3" />
                    </el-select>
                  </td>
                  <th>排序</th>
                  <td>
                    <el-input-number min="0" max="10" style="width:110px" :controls="false" v-model="tenant.seq" />
                  </td>
                </tr>
                <tr>
                  <th>
                    所属工单状态
                  </th>
                  <td colspan="7">
                    <el-select v-model="role" multiple placeholder="请选择" style="width: 100%;">
                      <el-option v-for="item in rolesOptions" :key="item.id" :label="item.label" :value="item.value
                        ">
                      </el-option>
                    </el-select>
                  </td>
                  <!-- 部门 -->
                </tr>

                <tr>
                  <th>
                    匹配服务类型
                  </th>
                  <td colspan="7" class="table-row">
                    <div class="table-cell">
                      <!-- <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeNames" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="selectServiceType"></i>
                      </el-input> -->
                      <!-- <el-select v-model="tenant.serviceTypeNames" multiple placeholder="请选择" style="width: 100%;">
                      <el-option v-for="item in serviceTypeOption" :key="item.id" :label="item.label" :value="item.value
                        ">
                      </el-option>
                    </el-select> -->
                    <el-cascader v-model="tenant.serviceTypeNames" :key="tenant.value" :options="serviceTypeOption"  style="width: 100%;"
                    :props="props"
    clearable

    ></el-cascader>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>创建人</th>
                  <td>{{ tenant.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ tenant.createTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
      @confirm="confirmCategory" />

<!--    <serviceTypeDialog v-if="showServiceTypeDialog" @commitSelectedRowService="commitSelectedRowService"
                       :visiable.sync="showServiceTypeDialog" multi="true" :param="serviceDialogParam"/>-->
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";
import { editPageMixins } from "@/mixins/tabChang";
import serviceTypeDialog from "@/views/dialogCommon/serviceTypeDialog.vue";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    serviceTypeDialog,
  },
  data() {
    return {
      props: { multiple: true },
      role: [],
      serviceTypeOption: [],

      rolesOptions: [
        { id: '1', label:"登记"        , value:"1" },
        { id: '2', label:"发布"        , value:"2" },
        { id: '5', label:"已派网点"    , value:"5" },
        { id: '6', label:"网点已接单"  , value:"6" },
        { id: '9', label:"已派师傅"    , value:"9" },
        { id: '10', label:"师傅已接单"  , value:"10" },
        { id: '11', label:"已预约"      , value:"11" },
        { id: '13', label:"已出发"      , value:"13" },
        { id: '17', label:"已上门"      , value:"17" },
        { id: '20', label:"完工暂存"    , value:"20" },
        { id: '30', label:"寄修待确认"  , value:"30" },
        { id: '31', label:"待寄件"      , value:"31" },
        { id: '32', label:"已寄待签收"  , value:"32" },
        { id: '36', label:"待维修"      , value:"36" },
        { id: '37', label:"修好待寄出"  , value:"37" },
        { id: '38', label:"客户待签收"  , value:"38" },
        { id: '40', label:"退换待确认"  , value:"40" },
        { id: '41', label:"旧机待退回"  , value:"41" },
        { id: '42', label:"旧机待签收"  , value:"42" },
        { id: '43', label:"旧机已签收"  , value:"43" },
        { id: '44', label:"新机待寄出"  , value:"44" },
        { id: '45', label:"新机已寄出"  , value:"45" },
        { id: '47', label:"新机待签收"  , value:"47" },
        { id: '48', label:"新机已签收"  , value:"48" },
        { id: '49', label:"退换被驳回"  , value:"49" },
        { id: '61', label:"已完工"      , value:"61" },
        { id: '62', label:"网点确认完工", value:"62" },
        { id: '63', label:"中心完工审核", value:"63" },
        { id: '64', label:"总部完工审核", value:"64" },
        { id: '91', label:"待结算"      , value:"91" },
        { id: '92', label:"结算驳回"    , value:"92" },
        { id: '93', label:"结算中止"    , value:"93" },
        { id: '94', label:"已结算"      , value:"94" },
        { id: '97', label:"申请关闭"    , value:"97" },
        { id: '98', label:"挂起"        , value:"98" },
        { id: '99', label:"取消"        , value:"99" },
        { id: '100', label:"结束"        , value:"100" },
      ],
      showServiceTypeDialog:false,
      dispatchStatEdit: false,
      dispatchStatAdd: false,
      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      intcColor: '',
      // 基本信息
      tenant: {
        id: null,
        status: 0,
        tenantAttachmentDTOs: [],
        dispatchStat: '',
        isShow: 1,
        showInSiteRemark: 0,
        showInRemark: 1,
        color: '',
        seq: 0,
        belongStats: [],
        belongStat: '',
        serviceTypeNames: [],
        serviceTypeIds: '',
        belongService: [],
      },
      showProductCategoryDialog: false,
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.dispatchStatEdit = this.permissions['dispatch_stat_edit']
    this.dispatchStatAdd = this.permissions['dispatch_stat_add']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {

    this.getData();
    this.loadServiceTypeOptions()

    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
        // 加载服务类型
        loadServiceTypeOptions() {
      this.$http.post(api.basServiceType.getOptionUrl, {}).then(res => {
        // console.log(res.data.data, 'option')
        let list = []
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item)
        })
        this.serviceTypeOption = list
        console.log(this.serviceTypeOption,"服务类实现");
      })
    },
    inspection() {
      if (this.tenant.dispatchStat) {
        this.$http({
          url: api.basDispatchStat.inspectionUrl,
          method: 'post',
          data: {
            value: this.tenant.dispatchStat,
            id: this.tenant.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("工单标签已存在，请重新输入")
            this.tenant.dispatchStat = null
          }
        })
      }
    },

    /*commitSelectedRowService(selectOrderTypeIds,selectOrderTypeNames) {
      this.tenant.serviceTypeNames = selectOrderTypeNames
      this.tenant.serviceTypeIds = selectOrderTypeIds
      console.log(this.tenant.serviceTypeNames)
      console.log(this.tenant.serviceTypeIds)
    },*/

    /*selectServiceType() {
      this.showServiceTypeDialog = true;
    },*/

    confirmSaleConfig(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.configGrid;
        const tableData3 = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function (item) {
          map[item.configId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            configId: row.id,
            configName: row.configName
          };
          if (index == 0 && tableData3.length == 0) {
            item.defaults = true;
          }
          if (!map[item.configId]) {
            items.push(item);
          }
        });
        this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
      }
    },
    // 上传成功

    // 第一个  表格
    formatter(row, column) {
      return row.address;
    },
    submitUpload() {
      this.$refs.upload.submit()
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: '/basic/basDispatchStat/get',
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.tenant = response.data.data;
          this.intcColor = response.data.data.color;
          this.tenant.color = this.intcColor - 0;

          let temp2 = []
          this.tenant.belongStats.forEach(item => {
            temp2.push(item)
          })
          this.role = temp2

          console.log("返回服务类型:"+response.data.data.serviceTypeOptions)
          this.tenant.serviceTypeNames = response.data.data.serviceTypeOptions;
        })
      } else {
        // this.enabled = true;
      }
    },
    saveData() {
      let temp2 = []
      var typeIds = "";
      if(this.tenant.serviceTypeNames != null){
        this.tenant.serviceTypeNames.forEach(item => {
          typeIds += item + ","
          temp2.push(item)
        })
      }
      if(typeIds != null && typeIds != ""){
        typeIds = typeIds.slice(0,typeIds.length-1);
      }

      this.tenant.serviceTypeIds = typeIds;
      if(typeIds == ""){
        this.tenant.serviceTypeIds = "0";
      }
      this.tenant.belongService = temp2
      this.tenant.belongStats = this.role
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = (this.isEdit ? `/basic/basDispatchStat/update` : `/basic/basDispatchStat/save`);
            this.$http({
              url: url,
              method: `post`,
              data: this.tenant,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              // this.$emit('editViewDataUpdate')
              this.goBackIndex()
              this.$mask.close()

            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },
    confirmCategory(rows) {
      if (rows.length > 0) {
        let row = rows[0];
        this.tenant.itemCatId = row.id;
        this.tenant.itemCatName = row.categoryName;
        this.tenant.itemCatCode = row.categoryCode;
      }
    },
  },
};

</script>
<style lang="scss" scoped>
::v-deep .el-select__tags > span {
  display: flex !important;;
}</style>
